function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUrlFromProps } from "../../resources/functions/";
import { isSelect, optionsList } from "../Schema/utils/";
import UserIcon from "../User/UserIcon";
import OwnerIcon from "../Owner/OwnerIcon";
import { ModuleBase, ModuleLink, ModuleMedia, ModuleHeader, ModuleFooter, ModuleTitle, ModuleDescription, ModuleLabel, ModuleMetadata, ModuleStatus, ModuleByline, ModuleActionbar //    NavSettings
} from '../Module/';
import AuthOptions from "./AuthOptions";
import "./AuthModule.scss";

class AuthModule extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onAuthChange", value => {
      if (this.props.onAuth) {
        this.props.onAuth(value);
      }
    });

    _defineProperty(this, "getProps", () => {
      let _this$props = this.props,
          metadata = _this$props.metadata,
          name = _this$props.name,
          title = _this$props.title,
          url = _this$props.url,
          urlPattern = _this$props.urlPattern,
          editUrl = _this$props.editUrl,
          editUrlPattern = _this$props.editUrlPattern;
      url = url || getUrlFromProps(this.props, urlPattern);
      editUrl = editUrl || getUrlFromProps(this.props, editUrlPattern);
      return _extends({}, this.props, {
        url: url,
        editUrl: editUrl,
        title: title || name,
        metadata: metadata
      });
    });

    _defineProperty(this, "getAuthSchemaOptions", schema => {
      const options = isSelect(schema) && optionsList(schema);

      if (!options) {
        return false;
      }

      return options;
    });

    _defineProperty(this, "getAuthOptions", () => {
      let _this$props2 = this.props,
          schema = _this$props2.schema,
          formData = _this$props2.formData,
          authName = _this$props2.authName,
          authValue = _this$props2.authValue,
          authOptions = _this$props2.authOptions;

      if (schema && schema.properties && schema.properties[authName]) {
        authOptions = this.getAuthSchemaOptions(schema.properties[authName]);
      }

      authValue = formData[authName] || this.props[authName] || authValue || undefined;
      return {
        options: authOptions,
        value: authValue
      };
    });

    _defineProperty(this, "renderFooter", () => {
      const _this$props3 = this.props,
            authorize = _this$props3.authorize,
            authStatus = _this$props3.authStatus,
            status = _this$props3.status;
      const authOptions = this.getAuthOptions();

      if (authOptions) {
        return React.createElement(ModuleFooter, null, React.createElement(AuthOptions, _extends({}, authOptions, {
          onChange: this.onAuthChange
        })), " ", ' ', React.createElement(ModuleStatus, {
          status: authStatus
        }));
      }

      return React.createElement(ModuleFooter, null, React.createElement(ModuleStatus, {
        status: status
      }), " ", ' ', React.createElement(ModuleByline, _extends({}, this.props, {
        name: false
      })));
    });

    _defineProperty(this, "renderHeader", () => {
      const _this$props4 = this.props,
            authType = _this$props4.authType,
            theme = _this$props4.theme,
            abbr = _this$props4.abbr,
            title = _this$props4.title,
            name = _this$props4.name,
            email = _this$props4.email,
            metadata = _this$props4.metadata,
            icon = _this$props4.icon;

      if (authType === "owner" || authType === "site") {
        return React.createElement(ModuleHeader, null, React.createElement(OwnerIcon, _extends({}, this.props, {
          abbr: abbr || name,
          title: name,
          theme: theme
        })), React.createElement("div", null, React.createElement(ModuleTitle, {
          title: title || name
        }), " ", ' ', React.createElement(ModuleLabel, this.props), " ", ' ', React.createElement(ModuleMetadata, {
          metadata: metadata
        })));
      }

      if (authType === "app") {
        return React.createElement(ModuleHeader, null, React.createElement(ModuleMedia, _extends({}, this.props, {
          svg: icon,
          mediaType: "svg"
        })), React.createElement("div", null, React.createElement(ModuleTitle, {
          title: title || name
        }), " ", ' ', React.createElement(ModuleLabel, this.props), " ", ' ', React.createElement(ModuleMetadata, {
          metadata: metadata
        })));
      }

      if (authType === "user") {
        return React.createElement(ModuleHeader, null, React.createElement(OwnerIcon, this.props), React.createElement("div", null, React.createElement(ModuleTitle, {
          title: title || name
        }), " ", ' ', React.createElement(ModuleLabel, this.props), " ", ' ', React.createElement(ModuleDescription, {
          description: email
        }), React.createElement(ModuleMetadata, {
          metadata: metadata
        })));
      }

      return React.createElement(ModuleHeader, null, React.createElement(ModuleMedia, this.props), React.createElement("div", null, React.createElement(ModuleTitle, {
        title: title
      }), " ", ' '));
    });
  }

  render() {
    const _this$getProps = this.getProps(),
          url = _this$getProps.url,
          editUrl = _this$getProps.editUrl,
          onClick = _this$getProps.onClick;

    return React.createElement(ModuleBase, this.props, React.createElement(ModuleLink, {
      url: url,
      onClick: onClick
    }, this.renderHeader()), this.renderFooter(), React.createElement(ModuleActionbar, _extends({}, this.props, {
      editUrl: editUrl
    })));
  }

}

_defineProperty(AuthModule, "defaultProps", {
  url: undefined,
  urlPattern: "/auth/:uniqueId",
  editUrl: undefined,
  editUrlPattern: undefined,
  moduleType: "auth",
  moduleLayout: "table",
  moduleSize: "auto",
  label: undefined,
  labelColor: undefined,
  action: ["edit", "remove", "select"],
  authorize: false,
  authName: "authId",
  authValue: undefined,
  authOptions: undefined,
  authStatus: undefined,
  formData: {},
  schema: {}
});

AuthModule.propTypes = process.env.NODE_ENV !== "production" ? {
  expanded: PropTypes.string,
  editable: PropTypes.string,
  editing: PropTypes.string,
  removable: PropTypes.string,
  authType: PropTypes.string,
  authOptions: PropTypes.array,
  authName: PropTypes.string,
  authValue: PropTypes.string,
  url: PropTypes.string,
  urlPattern: PropTypes.string,
  editUrl: PropTypes.string,
  editUrlPattern: PropTypes.string
} : {};
export default AuthModule;